export default __webpack_public_path__ + "static/media/Ouroboros Ring.6a572d57.jpg";